export const formatAnalysisDuration = (milliseconds: number, approximate = false): string => {
  const totalSeconds = Math.max(1, Math.round(milliseconds / 1_000));
  const totalMinutes = totalSeconds / 60;
  const prefix = approximate ? "~" : "";

  if (totalMinutes >= 24 * 60) return `${prefix}${Math.round(totalMinutes / (24 * 60))}d`;
  if (totalMinutes >= 60) return `${prefix}${Math.round(totalMinutes / 60)}h`;

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return minutes > 0 ? `${prefix}${minutes}m ${seconds}s` : `${prefix}${seconds}s`;
};
